import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBagIcon, XIcon } from "lucide-react";
import { purchases } from "../../data/purchases";
import { OFFER_HASH } from "../../data/links";
const FIRST_DELAY = 5000;
const VISIBLE_FOR = 5000;
const INTERVAL = 12000;
export function PurchasePopup() {
  const [index, setIndex] = useState<number | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let count = 0;
    let hideTimer: ReturnType<typeof setTimeout>;
    let interval: ReturnType<typeof setInterval>;
    const show = () => {
      setIndex(count % purchases.length);
      count += 1;
      hideTimer = setTimeout(() => setIndex(null), VISIBLE_FOR);
    };
    const firstTimer = setTimeout(() => {
      show();
      interval = setInterval(show, INTERVAL);
    }, FIRST_DELAY);
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, [dismissed]);
  const purchase = index !== null ? purchases[index] : null;
  return <div className="pointer-events-none fixed bottom-4 left-4 z-50" aria-live="polite" data-id="element-216" data-mp="37spdf2dpz8z6">
      <AnimatePresence data-id="element-217" data-mp="2svqa3qpwi2ai">
        {purchase && !dismissed && <motion.div key={purchase.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative w-[260px] rounded-xl border-2 border-gold bg-navy p-3 pr-8 shadow-[0_10px_28px_rgba(28,47,79,0.45)]" data-id="element-218" data-mp="2xtrtkcr8o3mi">
            <a href={OFFER_HASH} className="flex items-center gap-3" data-id="element-219" data-mp="3gr1bfpgx191n">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-220" data-mp="8ckb13x4o355">
                <ShoppingBagIcon className="h-4 w-4 text-navy" aria-hidden="true" data-id="element-221" data-mp="d4kj5jncq2ct" />
              </span>
              <span className="min-w-0" data-id="element-222" data-mp="mygd4veb9362">
                <span className="block truncate text-xs font-extrabold text-white" data-id="element-223" data-mp="mxex0ciftqhh">{purchase.name} · {purchase.location}</span>
                <span className="block text-[11px] font-semibold text-white/90" data-id="element-224" data-mp="dykw49y2qdy4">just bought Prenatal Training Pro 2026</span>
                <span className="block text-[10px] text-white/70" data-id="element-225" data-mp="8yorc8hjyihi">{purchase.time}</span>
              </span>
            </a>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-1.5 top-1.5 rounded p-1 text-white/70 transition-colors duration-150 hover:text-white" data-id="element-226" data-mp="4282fc2j403d">
              <XIcon className="h-3.5 w-3.5" data-id="element-227" data-mp="3mfxsiea5fygf" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}